<template>
  <v-form @submit.prevent="onSubmit">
    <embed-form :doc="doc" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import EmbedForm from "@/views/user/exercises/timeline/EmbedForm";

export default {
  name: "RowEdit",
  components: {
    EmbedForm,
  },
  props: {
    id: String,
    doc: {
      type: Object,
      default: () => {},
    },
    headers: Array,
  },
  methods: {
    onSubmit() {
      this.$emit("editCommit", this.doc);
    },
  },
};
</script>
